import AutocompletePrescriptor, { prescriptorRegistrado } from './shared/PrescriptorSelector';
import { PharmacySelect, PharmacyPagination, PharmacyMetric, PharmacyTabs } from './shared/PharmacyUI';
import React, { useState, useEffect, useCallback } from 'react';
import './shared/LibroPsicotropicos.css';
import { Box, Typography, CircularProgress, Tooltip, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import api from '../services/api';
import { HeaderIOS, IOS as BaseIOS } from './shared/MenuLayout';

const IOS={...BaseIOS,blue:'#548EE6',green:'#59AE88',purple:'#9380CD',red:'#D66F7C',orange:'#D99C55',separator:'#E7ECF3'};
const fmtFecha = (s) => {
  if (!s) return '—';
  const parte = String(s).split('T')[0].split(' ')[0];
  const bits = parte.split('-');
  if (bits.length !== 3) return '—';
  const [anio, mes, dia] = bits;
  if (!anio || !mes || !dia || anio === '0001') return '—';
  return `${dia.padStart(2,'0')}/${mes.padStart(2,'0')}/${anio}`;
};
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
const anioActual = new Date().getFullYear();
const mesActual  = new Date().getMonth() + 1;
const ANIOS = Array.from({ length:5 }, (_,i) => anioActual - i);

const Sel = PharmacySelect;

const Paginacion = PharmacyPagination;

const InputTabla = ({ value, onChange, placeholder, mono, blue, readOnly=false }) => (
  <input type="text" placeholder={placeholder} value={value} onChange={onChange} readOnly={readOnly} aria-readonly={readOnly}
    style={{ width:'100%', height:32, padding:'0 8px', boxSizing:'border-box',
      border:`1px solid ${blue&&value?`${IOS.blue}50`:IOS.separator}`,
      borderRadius:8, fontSize:'0.76rem', color:IOS.label,
      fontFamily:mono?'monospace':'inherit',
      backgroundColor:blue&&value?`${IOS.blue}08`:IOS.surface, outline:'none' }}
    onFocus={e=>e.target.style.borderColor=IOS.blue}
    onBlur={e=>e.target.style.borderColor=blue&&value?`${IOS.blue}50`:IOS.separator} />
);

const BtnDescarga = ({onClick,busy,label}) => (
  <Box component="button" type="button" className="pharmacy-layout pharmacy-action narcotic-download" aria-label={label} title={label} aria-busy={busy} onClick={onClick} disabled={busy}
    sx={{width:38,height:38,minWidth:38,minHeight:38,boxSizing:'border-box',flexShrink:0,p:0,
      borderRadius:'12px',border:'none',bgcolor:BaseIOS.green,color:'white',cursor:'pointer',
      display:'flex',alignItems:'center',justifyContent:'center',boxShadow:'none',
      transition:'filter 160ms ease','&:hover':{filter:'brightness(0.92)'},'&:disabled':{opacity:.55,cursor:'default'},
      '@media (prefers-reduced-motion: reduce)':{transition:'none'}}}>
    {busy ? <CircularProgress size={16} sx={{color:'white'}}/> : <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M12 3v13M7 11l5 5 5-5"/><path d="M4 20h16"/></svg>}
  </Box>
);

const KpiCard = PharmacyMetric;

const BtnGuardar = ({ listo, busy, ok, onClick }) => {
  if (ok) return (
    <Box sx={{ width:30, height:30, borderRadius:'50%', bgcolor:'#EDFAF2', border:'1px solid #B7EFD0',
      display:'inline-flex', alignItems:'center', justifyContent:'center' }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#1A6B3C" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>
    </Box>
  );
  return (
    <Box component="button" type="button" aria-label="Guardar cambios de receta" disabled={!listo||busy} onClick={()=>listo&&!busy&&onClick()}
      sx={{border:0,width:38,height:38,borderRadius:'12px',display:'inline-flex', alignItems:'center', justifyContent:'center',
        cursor:listo&&!busy?'pointer':'default', transition:'all 0.15s',
        bgcolor:listo?IOS.blue:'#E5E5EA', '&:hover':{ filter:listo?'brightness(0.9)':'none' } }}>
      {busy?<CircularProgress size={12} sx={{ color:'white' }} />
        :<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={listo?'white':'#8E8E93'} strokeWidth="2" strokeLinecap="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>}
    </Box>
  );
};

const TH = ({ children, center }) => (
  <th style={{ padding:'9px 10px', textAlign:center?'center':'left',
    fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.06em',
    textTransform:'uppercase', backgroundColor:IOS.surface,
    borderBottom:`1px solid ${IOS.separator}`, whiteSpace:'nowrap', position:'sticky', top:0, zIndex:1 }}>
    {children}
  </th>
);

const LibroPsicotropicos = () => {
  const navigate = useNavigate();
  const user        = authService.getCurrentUser();
  const ueId        = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento || 0;
  const userId      = user?.idUser || user?.IdUser || 1;
  const idEstabUsr  = String(user?.idEstablecimiento||user?.IdEstablecimiento||0);
  const [privPsico, setPrivPsico] = useState('Solo lectura');

  useEffect(()=>{
  api.get('/dashboard/permisos').then(r=>{
    if(r.data.success){
      const op = r.data.opciones.find(o=>
        (o.permiso||'').toLowerCase().includes('psicotrop')
      );
      if(op) setPrivPsico(op.privilegio||'Solo lectura');
    }
  }).catch(()=>{});
},[]);

const esTOTAL    = privPsico === 'Total';
const esPARCIAL  = privPsico === 'Lectura/Escritura';
const esSoloLect = privPsico === 'Solo lectura';

  const [tab, setTab] = useState(0);
  const [consultado, setConsultado] = useState(false);
  const [errorConsulta, setErrorConsulta] = useState('');
  const [ipressList, setIpressList]   = useState([]);
  const [loadIP,     setLoadIP]       = useState(true);
  const [productos,  setProductos]    = useState([]);
  const [loadProd,   setLoadProd]     = useState(false);
  const [prescriptores, setPrescriptores] = useState([]);
  const [filtroIpress, setFiltroIpress] = useState('');
  const [filtroProd,   setFiltroProd]   = useState('');
  const [filtroAnio,   setFiltroAnio]   = useState(String(anioActual));
  const [filtroMes,    setFiltroMes]    = useState(String(mesActual));

  const [pendientes, setPendientes]  = useState([]);
  const [loadPend,   setLoadPend]    = useState(false);
  const [ediciones,  setEdiciones]   = useState({});
  const [guardando,  setGuardando]   = useState({});
  const [guardadoOk, setGuardadoOk]  = useState({});
  const [pgPend,     setPgPend]      = useState(1);
  const [rppPend,    setRppPend]     = useState(() => window.matchMedia('(max-width:600px)').matches ? 10 : 20);

  const [dash,     setDash]     = useState([]);
  const [loadDash, setLoadDash] = useState(false);
  const [dashOpen, setDashOpen] = useState(true);

  const [detalle,      setDetalle]      = useState([]);
  const [loadHist,     setLoadHist]     = useState(false);
  const [busqDet,      setBusqDet]      = useState('');
  const [edicionesDet, setEdicionesDet] = useState({});
  const [guardandoDet, setGuardandoDet] = useState({});
  const [guardadoOkDet,setGuardadoOkDet]= useState({});
  const [pgDet,        setPgDet]        = useState(1);
  const [rppDet,       setRppDet]       = useState(() => window.matchMedia('(max-width:600px)').matches ? 10 : 20);
  const [pdfLoading,   setPdfLoading]   = useState(false);

  const handleLogout = () => { authService.logout(); navigate('/login'); };

  useEffect(() => {
    if(!privPsico) return;
    setLoadIP(true);
    api.get(`/farmacia/psicotropicos/listar-ipress?idEjecutora=${ueId}`)
      .then(r=>{
        const lista=(r.data?.data??[]).filter(x=>String(x.id)!=='0').map(x=>({id:String(x.id),nombre:x.nombre||''}));
        if(privPsico==='Total'){
          if(lista.length>0){ setIpressList(lista); const mi=lista.find(ip=>ip.id===idEstabUsr)||lista[0]; setFiltroIpress(mi.id); }
        } else {
          const su=lista.find(ip=>ip.id===idEstabUsr)||lista[0];
          if(su){setIpressList([su]);setFiltroIpress(su.id);}
        }
      }).catch(console.error).finally(()=>setLoadIP(false));
  }, [ueId, privPsico, idEstabUsr]);

  useEffect(() => {
    if(!filtroIpress) return;
    setLoadProd(true); setFiltroProd(''); setPendientes([]); setDetalle([]);
    api.get(`/farmacia/psicotropicos/listar-productos?idEjecutora=${ueId}`)
      .then(r=>{ const arr=r.data?.data??[]; setProductos(arr); if(arr.length>0) setFiltroProd(arr[0].medcod); })
      .catch(console.error).finally(()=>setLoadProd(false));
  }, [filtroIpress, ueId]);

  useEffect(() => { if(ueId) api.get(`/farmacia/psicotropicos/prescriptores?idUE=${ueId}`).then(r=>setPrescriptores(r.data?.data??[])).catch(console.error); }, [ueId]);

  useEffect(() => {
    if(!filtroIpress) return;
    setLoadDash(true); setDash([]);
    api.get(`/farmacia/psicotropicos/pendientes-dash?idEstablecimiento=${filtroIpress}`)
      .then(r=>{ if(r.data.success) setDash(r.data.data); })
      .catch(console.error).finally(()=>setLoadDash(false));
  }, [filtroIpress]);

  const consultarPendientes = useCallback(async () => {
    if(!filtroIpress||!filtroProd) return;
    setErrorConsulta('');setConsultado(false);setLoadPend(true); setPendientes([]); setEdiciones({}); setGuardadoOk({}); setPgPend(1);
    try { const r=await api.get('/farmacia/psicotropicos/pendientes',{params:{idEstablecimiento:filtroIpress,medcod:filtroProd}}); if(r.data.success){setPendientes(r.data.data);setConsultado(true);}else setErrorConsulta(r.data.message||'No se pudieron cargar las recetas.'); }
    catch(e){setErrorConsulta('No se pudieron cargar las recetas. Vuelve a consultar.');} finally{setLoadPend(false);}
  }, [filtroIpress,filtroProd]);

  const consultarHistorial = useCallback(async () => {
    if(!filtroIpress||!filtroProd) return;
    setLoadHist(true); setDetalle([]); setBusqDet(''); setEdicionesDet({}); setGuardadoOkDet({}); setPgDet(1);
    try { const r=await api.get('/farmacia/psicotropicos/historial-detalle',{params:{idEstablecimiento:filtroIpress,medcod:filtroProd,anio:filtroAnio,mes:filtroMes}}); if(r.data.success) setDetalle(r.data.data.map((x,i)=>({...x,_id:i}))); }
    catch(e){console.error(e);} finally{setLoadHist(false);}
  }, [filtroIpress,filtroProd,filtroAnio,filtroMes]);

  useEffect(()=>{setConsultado(false);setPendientes([]);setErrorConsulta('');},[filtroIpress,filtroProd]);

  const consultar = () => { tab===0?consultarPendientes():consultarHistorial(); };

  const guardarFila = async (row) => {
    if (!(esTOTAL || esPARCIAL)) { setErrorConsulta('Modo de solo lectura. Para completar pendientes necesitas Lectura/Escritura en Psicotrópicos.'); return; }
    setErrorConsulta('');
    const rowId=row.rc_id||`row-${row._idx}`; const ed=ediciones[rowId];
    if(!ed?.prescriptor||!ed?.colegiatura) return;
    setGuardando(prev=>({...prev,[rowId]:true}));
    try {
      const r=await api.post('/farmacia/psicotropicos/actualizar',{rcId:parseInt(row.rc_id),colegiatura:ed.colegiatura,prescriptor:ed.prescriptor,usuario:userId});
      if(r.data.success){
        setGuardadoOk(prev=>({...prev,[rowId]:true}));
        api.get(`/farmacia/psicotropicos/prescriptores?idUE=${ueId}`).then(r=>setPrescriptores(r.data?.data??[]));
        setTimeout(()=>{ setPendientes(prev=>prev.filter(p=>(p.rc_id||`row-${p._idx}`)!==rowId)); setGuardadoOk(prev=>{const n={...prev};delete n[rowId];return n;}); },1200);
      } else setErrorConsulta(r.data.message || 'No se pudo guardar la receta.');
    } catch(e){setErrorConsulta(e.response?.data?.message || 'No se pudo guardar la receta. Revisa tus permisos e inténtalo nuevamente.');} finally{setGuardando(prev=>({...prev,[rowId]:false}));}
  };

  const guardarDetalle = async (row) => {
    if (!esTOTAL) { setErrorConsulta('Para corregir recetas completas necesitas permiso Total en Psicotrópicos.'); return; }
    setErrorConsulta('');
    const rowId=String(row._id); const ed=edicionesDet[rowId];
    if(!ed?.prescriptor||!ed?.colegiatura) return;
    setGuardandoDet(prev=>({...prev,[rowId]:true}));
    try {
      const r=await api.post('/farmacia/psicotropicos/actualizar',{rcId:parseInt(row.rc_id||row.RC_ID),colegiatura:ed.colegiatura,prescriptor:ed.prescriptor,usuario:userId});
      if(r.data.success){
        setGuardadoOkDet(prev=>({...prev,[rowId]:true}));
        setDetalle(prev=>prev.map(d=>String(d._id)===rowId?{...d,rc_prescriptor:ed.prescriptor,rc_colegiatura:ed.colegiatura}:d));
        api.get(`/farmacia/psicotropicos/prescriptores?idUE=${ueId}`).then(r=>setPrescriptores(r.data?.data??[]));
        setTimeout(()=>setGuardadoOkDet(prev=>{const n={...prev};delete n[rowId];return n;}),2000);
      }
    } catch(e){setErrorConsulta(e.response?.data?.message || 'No se pudo guardar la corrección. Inténtalo nuevamente.');} finally{setGuardandoDet(prev=>({...prev,[rowId]:false}));}
  };

  const exportarPdf = async () => {
    if(!detalle.length||pdfLoading) return;
    setPdfLoading(true);
    try {
      const ipress=ipressList.find(ip=>ip.id===filtroIpress);
      const payload={ idEstablecimiento:parseInt(filtroIpress), medCod:filtroProd, producto:prodNombre, farmacia:ipress?.nombre||'', periodo:`${MESES[parseInt(filtroMes)-1]} ${filtroAnio}`,
        datos:detalle.map(d=>({ rs:d.rc_medregsan||'', producto:d.rc_producto||prodNombre, nombreComercial:d.rc_producto||prodNombre, cont:d.rc_concentracion||'', pres:d.rc_presentacion||'', ff:d.rc_forma_f||d.rc_tipo||'', lote:d.rc_medlote||'', prescriptor:d.rc_prescriptor||'', colegiatura:d.rc_colegiatura||'', paciente:d.rc_paciente||'', fecha:d.rc_fecha||'', cantAtendida:parseInt(d.rc_cantidad||0) })) };
      const resp=await api.post('/farmacia/psicotropicos/exportar-pdf',payload,{responseType:'blob'});
      const a=document.createElement('a'); a.href=window.URL.createObjectURL(new Blob([resp.data],{type:'application/pdf'}));
      a.download=`LibroPsicotropicos_${filtroProd}_${filtroAnio}${String(filtroMes).padStart(2,'0')}.pdf`; a.click(); window.URL.revokeObjectURL(a.href);
    } catch(e){console.error(e);} finally{setPdfLoading(false);}
  };

  const prodNombre = productos.find(p=>p.medcod===filtroProd)?.producto||'';
  const totalPend  = pendientes.length;
  const editados   = Object.keys(ediciones).filter(k=>ediciones[k]?.prescriptor&&ediciones[k]?.colegiatura).length;
  const pagPend    = pendientes.slice((pgPend-1)*rppPend, pgPend*rppPend);
  const detFiltrado= detalle.filter(d=>{ if(!busqDet||busqDet.length<2) return true; const b=busqDet.toUpperCase(); return (d.rc_numero||d.RC_NUMERO||'').toUpperCase().includes(b)||(d.rc_paciente||d.RC_PACIENTE||'').toUpperCase().includes(b)||(d.rc_prescriptor||d.RC_PRESCRIPTOR||'').toUpperCase().includes(b); });
  const detPag     = detFiltrado.slice((pgDet-1)*rppDet, pgDet*rppDet);

  return (
    <Box className="pharmacy-page psychotropics-page" sx={{ minHeight:'100vh', bgcolor:IOS.bg }}>
      <HeaderIOS titulo="Libro Psicotrópicos" subtitulo="Farmacia"
        onHome={()=>navigate('/farmacia')} onLogout={handleLogout}
        nombreCompleto={user?.nombreCompleto||user?.usuario||''}
        avatarLetra={(user?.nombreCompleto||user?.usuario||'U').charAt(0).toUpperCase()} />

      {/* Tabs */}
      <Box className="pharmacy-tabs-row"><PharmacyTabs value={tab} onChange={setTab} options={[{label:'Pendientes',badge:totalPend>0&&totalPend},{label:'Historial'}]}/></Box>

      <Box className="pharmacy-content" sx={{ maxWidth:1600, mx:'auto', px:{ xs:1.5, sm:2.6 }, pt:2.5, pb:6 }}>
        <div className="psychotropics-heading"><span>Psicotrópicos · Farmacia</span><h1>{["Cada receta, en orden","La historia de cada dispensación"][tab]}</h1><p>{["Completa los datos pendientes de las recetas de psicotrópicos.","Consulta las recetas y revisa su registro de dispensación."][tab]}</p></div>
        {errorConsulta&&<Alert severity="error" sx={{mb:2,borderRadius:3}}>{errorConsulta}</Alert>}

        {/* Panel diagnóstico */}
        {tab===0 && (loadDash||dash.length>0) && (
          <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', mb:2,
            boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid #FFE9A0`, overflow:'hidden' }}>
            <Box className="pharmacy-layout" onClick={()=>setDashOpen(v=>!v)}
              sx={{ px:2.5, py:1.5, bgcolor:'#FFFDF0', borderBottom:dashOpen?`1px solid #FFE9A0`:'none',
                display:'flex', alignItems:'center', justifyContent:'space-between', cursor:'pointer',
                '&:hover':{ bgcolor:'#FFF8E6' }, transition:'background 0.15s' }}>
              <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
                <Box className="pharmacy-layout" sx={{ width:28, height:28, borderRadius:'8px', bgcolor:'#FFE9A0',
                  display:'flex', alignItems:'center', justifyContent:'center' }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8B6914" strokeWidth="2" strokeLinecap="round">
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                </Box>
                <Typography sx={{ fontWeight:700, fontSize:'0.85rem', color:'#8B6914' }}>Diagnóstico de Pendientes</Typography>
                {!loadDash && (
                  <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px',
                    bgcolor:dash.some(d=>d.total_recetas>0)?'#FFF0EF':'#EDFAF2',
                    border:`1px solid ${dash.some(d=>d.total_recetas>0)?'#FFD4D1':'#B7EFD0'}` }}>
                    <Box sx={{ width:5, height:5, borderRadius:'50%', bgcolor:dash.some(d=>d.total_recetas>0)?IOS.red:IOS.green }} />
                    <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:dash.some(d=>d.total_recetas>0)?'#C0392B':'#1A6B3C' }}>
                      {dash.filter(d=>d.total_recetas>0).length} med. con pendientes
                    </Typography>
                  </Box>
                )}
              </Box>
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                style={{ transform:dashOpen?'rotate(180deg)':'none', transition:'transform 0.2s' }}>
                <polyline points="6 9 12 15 18 9" stroke="#8B6914" strokeWidth="2.5" strokeLinecap="round"/>
              </svg>
            </Box>
            {dashOpen && (
              <Box sx={{ p:2 }}>
                {loadDash
                  ? <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, py:1 }}>
                      <CircularProgress size={16} sx={{ color:IOS.blue }} />
                      <Typography sx={{ fontSize:'0.8rem', color:IOS.label2 }}>Cargando diagnóstico...</Typography>
                    </Box>
                  : <Box className="pharmacy-layout" sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
                      {dash.map((d,i)=>{
                        const tienePend=d.total_recetas>0;
                        return (
                          <Box className="pharmacy-layout" key={i} onClick={()=>{
                            const medcod=d.rc_medcod; setFiltroProd(medcod); setTab(0);
                            setTimeout(async()=>{
                              if(!filtroIpress||!medcod) return;
                              setLoadPend(true); setPendientes([]); setEdiciones({}); setGuardadoOk({}); setPgPend(1);
                              try{ const r=await api.get('/farmacia/psicotropicos/pendientes',{params:{idEstablecimiento:filtroIpress,medcod}}); if(r.data.success) setPendientes(r.data.data); }
                              catch(e){console.error(e);} finally{setLoadPend(false);}
                            },50);
                          }}
                            sx={{ display:'flex', alignItems:'center', gap:1, px:1.5, py:0.8, borderRadius:'12px',
                              cursor:'pointer', transition:'all 0.15s',
                              bgcolor:tienePend?'#FFF0EF':'#EDFAF2',
                              border:`1px solid ${tienePend?'#FFD4D1':'#B7EFD0'}`,
                              '&:hover':{ transform:'translateY(-1px)', boxShadow:'0 2px 8px rgba(0,0,0,0.08)' } }}>
                            <Box>
                              <Typography sx={{ fontSize:'0.72rem', fontWeight:700, color:tienePend?'#C0392B':'#1A6B3C', lineHeight:1.2 }}>
                                {d.rc_producto?.length>32?d.rc_producto.substring(0,32)+'…':d.rc_producto}
                              </Typography>
                              <Typography sx={{ fontSize: '0.72rem', color:IOS.label2, fontFamily:'monospace' }}>{d.rc_medcod}</Typography>
                            </Box>
                            <Box className="pharmacy-layout" sx={{ minWidth:22, height:22, borderRadius:'20px', display:'flex', alignItems:'center', justifyContent:'center', px:0.8,
                              bgcolor:tienePend?IOS.red:IOS.green }}>
                              <Typography sx={{ fontSize: '0.72rem', fontWeight:800, color:'white' }}>{d.total_recetas}</Typography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                }
              </Box>
            )}
          </Box>
        )}

        {/* Filtros */}
        <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2,
          boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, mb:2.5 }}>
          <Box className="pharmacy-layout pharmacy-toolbar psychotropics-filters" sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'flex-end' }}>
            {(esPARCIAL || esSoloLect)
              ? <Box className="pharmacy-layout" sx={{ display:'flex', flexDirection:'column', gap:0.3 }}>
                  <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase' }}>IPRESS</Typography>
                  <Box className="pharmacy-layout" sx={{ height:34, px:1.5, display:'flex', alignItems:'center', border:`1px solid ${IOS.separator}`, borderRadius:8, bgcolor:IOS.bg, minWidth:200 }}>
                    <Typography sx={{ fontSize:'0.8rem', color:IOS.label2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{ipressList[0]?.nombre||'Cargando...'}</Typography>
                  </Box>
                </Box>
              : <Sel label="IPRESS" value={filtroIpress} onChange={e=>setFiltroIpress(e.target.value)} disabled={loadIP} w={220}>
                  {loadIP?<option>Cargando...</option>:ipressList.map(ip=><option key={ip.id} value={ip.id}>{ip.nombre}</option>)}
                </Sel>
            }
            <Sel label="Medicamento" value={filtroProd} onChange={e=>setFiltroProd(e.target.value)} disabled={loadProd||productos.length===0} w={320}>
              {loadProd?<option>Cargando...</option>:productos.map(p=><option key={p.medcod} value={p.medcod}>{p.medcod} — {p.producto}</option>)}
            </Sel>
            {tab===1 && <>
              <Sel label="Año" value={filtroAnio} onChange={e=>setFiltroAnio(e.target.value)} w={80}>
                {ANIOS.map(a=><option key={a} value={String(a)}>{a}</option>)}
              </Sel>
              <Sel label="Mes" value={filtroMes} onChange={e=>setFiltroMes(e.target.value)} w={110}>
                {MESES.map((m,i)=><option key={i+1} value={String(i+1)}>{String(i+1).padStart(2,'0')} {m}</option>)}
              </Sel>
            </>}
            <Box className="pharmacy-layout pharmacy-action" component="button" onClick={consultar}
              disabled={(tab===0?loadPend:loadHist)||!filtroIpress||!filtroProd}
              sx={{ height:34, px:2.5, borderRadius:'10px', border:'none', alignSelf:'flex-end',
                bgcolor:IOS.blue, cursor:((tab===0?loadPend:loadHist)||!filtroIpress||!filtroProd)?'default':'pointer',
                display:'flex', alignItems:'center', gap:0.8, opacity:(!filtroIpress||!filtroProd)?0.5:1,
                transition:'all 0.2s', '&:hover':{ filter:'brightness(0.92)' } }}>
              {(tab===0?loadPend:loadHist)?<CircularProgress size={13} sx={{ color:'white' }} />:null}
              <Typography sx={{ fontSize:'0.8rem', fontWeight:700, color:'white' }}>
                {(tab===0?loadPend:loadHist)?'Consultando...':'Consultar'}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ══ TAB 0: PENDIENTES ══ */}
        {tab===0 && (
          <>
            {loadPend && <Box sx={{ py:10, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}
            {!loadPend && pendientes.length===0 && !consultado && (
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                <Box className="pharmacy-layout" sx={{ width:56, height:56, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                </Box>
                <Typography sx={{ fontWeight:700, color:IOS.label, mb:0.5 }}>Selecciona IPRESS y medicamento</Typography>
                <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Presiona Consultar para ver las recetas pendientes</Typography>
              </Box>
            )}
              {!loadPend && consultado && pendientes.length===0 && !errorConsulta && (
                <section className="pharmacy-card psychotropic-all-clear" role="status">
                  <span className="psychotropic-all-clear-icon" aria-hidden="true">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/></svg>
                  </span>
                  <h2>Todo al día</h2>
                  <p>No hay recetas pendientes para este medicamento.</p>
                  <div className="psychotropic-sync-note">
                    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M20 7v5h-5M4 17v-5h5"/><path d="M6.1 7a7 7 0 0 1 11.5-1L20 9M4 15l2.4 3A7 7 0 0 0 17.9 17"/></svg>
                    <span>Recuerda sincronizar con <strong>SISMED</strong>.</span>
                  </div>
                </section>
              )}
            {!loadPend && pendientes.length>0 && (
              <>
                <Box className="pharmacy-layout" sx={{ display:'grid', gridTemplateColumns:{xs:'repeat(2,minmax(0,1fr))',md:'repeat(3,minmax(0,1fr))'}, gap:1.5, mb:2 }}>
                  <KpiCard label="Pendientes" valor={totalPend.toLocaleString()} sub="recetas sin completar" color={IOS.red}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.red} strokeWidth="1.8" strokeLinecap="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>} />
                  <KpiCard label="Listos para guardar" valor={editados} sub="con prescriptor llenado" color={IOS.green}
                    icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={IOS.green} strokeWidth="1.8" strokeLinecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>} />
                  <Box className="pharmacy-layout pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', p:2.2, boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, display:'flex', alignItems:'center', gap:1.5 }}>
                    <Box className="pharmacy-layout" sx={{ width:44, height:44, borderRadius:'12px', bgcolor:`${IOS.orange}12`, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={IOS.orange} strokeWidth="1.8" strokeLinecap="round"><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L18.5 2.5z"/></svg>
                    </Box>
                    <Box sx={{ minWidth:0 }}>
                      <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.label2, letterSpacing:'0.07em', textTransform:'uppercase', mb:0.3 }}>Medicamento</Typography>
                      <Typography sx={{ fontWeight:700, fontSize:'0.82rem', color:IOS.label, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{prodNombre}</Typography>
                      <Typography sx={{ fontSize:'0.7rem', color:IOS.blue, fontFamily:'monospace' }}>{filtroProd}</Typography>
                    </Box>
                  </Box>
                </Box>

                <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                  <Box className="pharmacy-layout" sx={{ px:2.5, py:1.8, borderBottom:`1px solid ${IOS.separator}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <Box>
                      <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>Recetas Pendientes de Completar</Typography>
                      <Typography sx={{ fontSize:'0.7rem', color:IOS.label2, mt:0.2 }}>Llena el prescriptor y colegiatura para cada receta</Typography>
                    </Box>
                    {prescriptores.length>0 && (
                      <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:1, py:0.3, borderRadius:'20px', bgcolor:`${IOS.blue}12`, border:`1px solid ${IOS.blue}30` }}>
                        <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue }}>{prescriptores.length} prescriptores</Typography>
                      </Box>
                    )}
                  </Box>
                  {!(esTOTAL || esPARCIAL) && <Alert severity="info" sx={{m:2,borderRadius:3}}>Modo de solo lectura. Para completar pendientes necesitas Lectura/Escritura en Psicotrópicos.</Alert>}
                  <Box component="fieldset" disabled={!(esTOTAL || esPARCIAL)} sx={{border:0,p:0,m:0,minWidth:0}}>
                  <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 500px)',
                    '&::-webkit-scrollbar':{ width:4, height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                    <table style={{ width:'100%', borderCollapse:'collapse', minWidth:800, fontSize:'0.75rem' }}>
                      <thead><tr>
                        <TH>#</TH><TH>Fecha</TH><TH>Nº Comprobante</TH><TH>Paciente</TH><TH>DNI</TH>
                        <TH>Prescriptor</TH><TH>Colegiatura</TH><TH center></TH>
                      </tr></thead>
                      <tbody>
                        {pagPend.map((row,idx)=>{
                          const rowId=row.rc_id||`row-${idx}`; const ed=ediciones[rowId]||{};
                          const ok=guardadoOk[rowId]; const busy=guardando[rowId];
                          const listo=ed.prescriptor&&ed.colegiatura;
                          return (
                            <tr key={rowId} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:ok?'#EDFAF2':IOS.surface, transition:'background 0.1s' }}
                              onMouseEnter={e=>{ if(!ok) e.currentTarget.style.backgroundColor=IOS.bg; }}
                              onMouseLeave={e=>{ e.currentTarget.style.backgroundColor=ok?'#EDFAF2':IOS.surface; }}>
                              <td data-label="Nº" style={{ padding:'6px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{(pgPend-1)*rppPend+idx+1}</td>
                              <td data-label="Fecha" style={{ padding:'6px 10px', color:IOS.label2, fontSize:'0.7rem', whiteSpace:'nowrap' }}>{fmtFecha(row.RC_FECHA||row.rc_fecha)}</td>
                              <td data-label="Comprobante" style={{ padding:'6px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{row.rc_comprobante_numero||row.rc_numero||'—'}</td>
                              <td data-label="Paciente" style={{ padding:'6px 10px', maxWidth:180 }}>
                                <Tooltip title={row.RC_PACIENTE||row.rc_paciente||''} placement="top">
                                  <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180, color:IOS.label, fontSize:'0.73rem' }}>{row.RC_PACIENTE||row.rc_paciente||'—'}</span>
                                </Tooltip>
                              </td>
                              <td data-label="DNI" style={{ padding:'6px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{row.RC_DNI||row.rc_dni||'—'}</td>
                              <td data-label="Prescriptor" style={{ padding:'4px 6px', minWidth:200 }}>
                                <AutocompletePrescriptor colegiatura={ed.colegiatura||''} value={ed.prescriptor||''} sugerencias={prescriptores} placeholder="Prescriptor..."
                                  onChange={({prescriptor,colegiatura})=>setEdiciones(prev=>({...prev,[rowId]:{prescriptor,colegiatura}}))} />
                              </td>
                              <td data-label="Colegiatura" style={{ padding:'4px 6px', minWidth:110 }}>
                                <InputTabla readOnly={Boolean(prescriptorRegistrado(prescriptores,ed.prescriptor,ed.colegiatura))} value={ed.colegiatura||''} mono blue placeholder="CMP / COP"
                                  onChange={e=>setEdiciones(prev=>({...prev,[rowId]:{...prev[rowId],colegiatura:e.target.value}}))} />
                              </td>
                              <td data-label="Guardar" style={{ padding:'4px 8px', textAlign:'center', width:40 }}>
                                <Tooltip title={listo?'Guardar':'Completa prescriptor y colegiatura'} placement="top">
                                  <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'center' }}>
                                    <BtnGuardar listo={listo} busy={busy} ok={ok} onClick={()=>guardarFila(row)} />
                                  </Box>
                                </Tooltip>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </Box>
                  </Box>
                  <Paginacion total={pendientes.length} pagina={pgPend} setPagina={setPgPend} rpp={rppPend} setRpp={setRppPend} />
                </Box>
              </>
            )}
          </>
        )}

        {/* ══ TAB 1: HISTORIAL ══ */}
        {tab===1 && (
          <>
            {loadHist && <Box sx={{ py:10, textAlign:'center' }}><CircularProgress sx={{ color:IOS.blue }} /></Box>}
            {!loadHist && detalle.length===0 && (
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', py:10, textAlign:'center', border:`1px solid ${IOS.separator}` }}>
                <Box className="pharmacy-layout" sx={{ width:56, height:56, borderRadius:'50%', bgcolor:`${IOS.blue}12`, display:'flex', alignItems:'center', justifyContent:'center', mx:'auto', mb:2 }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={IOS.blue} strokeWidth="1.8" strokeLinecap="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
                  </svg>
                </Box>
                <Typography sx={{ fontWeight:700, color:IOS.label, mb:0.5 }}>Historial de recetas</Typography>
                <Typography sx={{ color:IOS.label2, fontSize:'0.82rem' }}>Selecciona IPRESS, medicamento, año y mes — luego Consultar</Typography>
              </Box>
            )}
            {!loadHist && detalle.length>0 && (
              <Box className="pharmacy-card" sx={{ bgcolor:IOS.surface, borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.07)', border:`1px solid ${IOS.separator}`, overflow:'hidden' }}>
                <Box sx={{ px:2.5, py:2, borderBottom:`1px solid ${IOS.separator}` }}>
                  <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', mb:1.5 }}>
                    <Box>
                      <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:IOS.label }}>
                        Recetas — {MESES[parseInt(filtroMes)-1]} {filtroAnio}
                      </Typography>
                      <Box className="pharmacy-layout" sx={{ display:'flex', alignItems:'center', gap:1.5, mt:0.3 }}>
                        <Typography sx={{ fontSize:'0.7rem', color:IOS.label2 }}>{detFiltrado.length.toLocaleString()} de {detalle.length.toLocaleString()} recetas</Typography>
                        <Box sx={{ display:'inline-flex', alignItems:'center', gap:0.5, px:0.8, py:0.2, borderRadius:'20px', bgcolor:`${IOS.blue}12` }}>
                          <Typography sx={{ fontSize: '0.72rem', fontWeight:700, color:IOS.blue, fontFamily:'monospace' }}>{filtroProd}</Typography>
                        </Box>
                      </Box>
                    </Box>
                    <BtnDescarga onClick={exportarPdf} busy={pdfLoading} label="Descargar libro en PDF" />
                  </Box>
                  <Box sx={{ position:'relative', maxWidth:400 }}>
                    <Box sx={{ position:'absolute', left:9, top:'50%', transform:'translateY(-50%)', pointerEvents:'none', color:IOS.label2 }}>
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
                    </Box>
                    <input aria-label="Buscar en historial" type="text" placeholder="Buscar por Nº comprobante, paciente o prescriptor..." value={busqDet}
                      onChange={e=>{setBusqDet(e.target.value);setPgDet(1);}}
                      style={{ width:'100%', height:34, paddingLeft:28, paddingRight:10, border:`1px solid ${IOS.separator}`, borderRadius:8, fontSize:'0.78rem', color:IOS.label, backgroundColor:IOS.surface, outline:'none', boxSizing:'border-box', fontFamily:'inherit' }}
                      onFocus={e=>e.target.style.borderColor=IOS.blue}
                      onBlur={e=>e.target.style.borderColor=IOS.separator} />
                  </Box>
                </Box>
                {!esTOTAL && <Alert severity="info" sx={{m:2,borderRadius:3}}>Historial en modo de consulta. Las correcciones requieren permiso Total en Psicotrópicos.</Alert>}
                <Box component="fieldset" disabled={!esTOTAL} sx={{border:0,p:0,m:0,minWidth:0}}>
                <Box className="pharmacy-scroll" tabIndex={0} role="region" aria-label="Tabla de resultados, desplazamiento horizontal" sx={{ overflowX:'auto', overflowY:'auto', maxHeight:'calc(100vh - 420px)',
                  '&::-webkit-scrollbar':{ width:4, height:4 }, '&::-webkit-scrollbar-thumb':{ bgcolor:IOS.separator, borderRadius:4 } }}>
                  <table style={{ width:'100%', borderCollapse:'collapse', minWidth:800, fontSize:'0.75rem' }}>
                    <thead><tr>
                      <TH>#</TH><TH>Fecha</TH><TH>Nº Receta</TH><TH>Paciente</TH><TH>DNI</TH>
                      <TH>Prescriptor</TH><TH>Colegiatura</TH><TH center></TH>
                    </tr></thead>
                    <tbody>
                      {detPag.map((row,idx)=>{
                        const rowId=String(row._id); const ed=edicionesDet[rowId]||{};
                        const ok=guardadoOkDet[rowId]; const busy=guardandoDet[rowId];
                        const prescActual=ed.prescriptor!==undefined?ed.prescriptor:(row.RC_PRESCRIPTOR||row.rc_prescriptor||'');
                        const cmpActual  =ed.colegiatura!==undefined?ed.colegiatura:(row.RC_COLEGIATURA||row.rc_colegiatura||'');
                        const cambiado=ed.prescriptor!==undefined||ed.colegiatura!==undefined;
                        const listo=prescActual&&cmpActual;
                        return (
                          <tr key={rowId} style={{ borderBottom:`1px solid ${IOS.separator}`, backgroundColor:ok?'#EDFAF2':IOS.surface, transition:'background 0.1s' }}
                            onMouseEnter={e=>{ if(!ok) e.currentTarget.style.backgroundColor=IOS.bg; }}
                            onMouseLeave={e=>{ e.currentTarget.style.backgroundColor=ok?'#EDFAF2':IOS.surface; }}>
                            <td data-label="Nº" style={{ padding:'6px 10px', color:IOS.label3, fontSize:'0.7rem' }}>{(pgDet-1)*rppDet+idx+1}</td>
                            <td data-label="Fecha" style={{ padding:'6px 10px', color:IOS.label2, fontSize:'0.7rem', whiteSpace:'nowrap' }}>{fmtFecha(row.RC_FECHA||row.rc_fecha)}</td>
                            <td data-label="Comprobante" style={{ padding:'6px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{row.rc_comprobante_numero||row.rc_numero||'—'}</td>
                            <td data-label="Paciente" style={{ padding:'6px 10px', maxWidth:180 }}>
                              <Tooltip title={row.RC_PACIENTE||row.rc_paciente||''} placement="top">
                                <span style={{ display:'block', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', maxWidth:180, color:IOS.label, fontSize:'0.73rem' }}>{row.RC_PACIENTE||row.rc_paciente||'—'}</span>
                              </Tooltip>
                            </td>
                            <td data-label="DNI" style={{ padding:'6px 10px', fontFamily:'monospace', color:IOS.label2, fontSize:'0.7rem' }}>{row.RC_DNI||row.rc_dni||'—'}</td>
                            <td data-label="Prescriptor" style={{ padding:'4px 6px', minWidth:200 }}>
                              <AutocompletePrescriptor colegiatura={cmpActual} value={prescActual} sugerencias={prescriptores} placeholder="Prescriptor..."
                                onChange={({prescriptor,colegiatura})=>setEdicionesDet(prev=>({...prev,[rowId]:{prescriptor,colegiatura}}))} />
                            </td>
                            <td data-label="Colegiatura" style={{ padding:'4px 6px', minWidth:110 }}>
                              <InputTabla readOnly={Boolean(prescriptorRegistrado(prescriptores,prescActual,cmpActual))} value={cmpActual} mono blue placeholder="CMP / COP"
                                onChange={e=>setEdicionesDet(prev=>({...prev,[rowId]:{...prev[rowId],prescriptor:prescActual,colegiatura:e.target.value}}))} />
                            </td>
                            <td data-label="Guardar" style={{ padding:'4px 8px', textAlign:'center', width:40 }}>
                              <Tooltip title={cambiado&&listo?'Guardar':!cambiado?'Sin cambios':'Completa los campos'} placement="top">
                                <Box className="pharmacy-layout" sx={{ display:'flex', justifyContent:'center' }}>
                                  <BtnGuardar listo={cambiado&&listo} busy={busy} ok={ok} onClick={()=>guardarDetalle(row)} />
                                </Box>
                              </Tooltip>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Box>
                </Box>
                <Paginacion total={detFiltrado.length} pagina={pgDet} setPagina={setPgDet} rpp={rppDet} setRpp={setRppDet} />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default LibroPsicotropicos;
